import { render, staticRenderFns } from "./AamsQualificationRegApproval.vue?vue&type=template&id=07568515&scoped=true&"
import script from "./AamsQualificationRegApproval.vue?vue&type=script&lang=js&"
export * from "./AamsQualificationRegApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07568515",
  null
  
)

export default component.exports